import moment from "moment";
import BlockScroller from "../BlockScroller";
import { IBlockComponentProps } from "../_Block";
import styles from "./PageBlock.module.scss";
import { ErrorBoundary } from "../../../utilities/rollbar/ErrorBoundary";

interface IPageBlockProps extends IBlockComponentProps {
  blockObj: IPageBlockObj;
}

function PageBlockInner(props: IPageBlockProps) {
  const title = props.blockObj.pageTitle.replace("/Page.?$/is", "");

  return (
    <ErrorBoundary>
      <BlockScroller
        className="sb-page-b scoped-content-builder"
        blockRef={props.blockRef}
        blockObj={props.blockObj}
        setShowExpandButton={props.setShowExpandButton}
        outsideGrid={props.outsideGrid}
      >
        <div className="sb-blockContent">
          <h3 className="sb-page-b-title">{props.blockObj.pageTitle}</h3>
          <p className="sb-page-b-modified sb-hidden-xs">
            {moment(props.blockObj.modified).from(moment())}
          </p>
          <div
            className={`sb-page-b-content sb-page-body ${styles.content}`}
            dangerouslySetInnerHTML={{ __html: props.blockObj.pageContent }}
          />
        </div>
      </BlockScroller>
      <div className="sb-read-more text-center">
        <a
          href={props.blockObj.pageUrl}
          className="btn sb-read-more-btn sb-block-link sb-organization-color-element-bg"
          target="_self"
          title={`Visit ${title.trim()} Page`}
        >
          visit page
        </a>
      </div>
    </ErrorBoundary>
  );
}

export default function PageBlock(props: IPageBlockProps) {
  return (
    <ErrorBoundary>
      <PageBlockInner {...props} />
    </ErrorBoundary>
  );
}
